import React, { useEffect, useState } from "react";
import styled from "styled-components";
const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(48 48 48 / 98%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  overflow: hidden; /* Prevent scrolling */
`;
const LoaderText = styled.div`
  /* position: absolute; */
  font-size: 25px !important;
  color: black;
  top: 500px;
  margin-top: 20px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  max-width: 80%;
  transition: opacity 0.5s;
`;
const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const TransactionLoader = ({ isEstimate }) => {
  const [loaderText, setLoaderText] = useState([
    `Please wait while your transaction is processing...`,
    `Please do not reload or press back button...`,
  ]);
  const [estimateText, setEstimateText] = useState([
    `Estimating Transaction fees, please wait...`,
    `Please do not reload or press back button...`,
  ]);
  const [loaderTextIndex, setLoaderTextIndex] = useState(0);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "visible";
    };
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setLoaderTextIndex((prevIndex) => (prevIndex + 1) % loaderText.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <LoaderContainer>
        <Loader />
        {isEstimate == true ? (
          <LoaderText>{estimateText[loaderTextIndex]}</LoaderText>
        ) : (
          <LoaderText>{loaderText[loaderTextIndex]}</LoaderText>
        )}
      </LoaderContainer>
    </>
  );
};

export default TransactionLoader;
